// extracted by mini-css-extract-plugin
module.exports = {"emoji":"ParentTopbar_emoji__zRoJ2"};